import swal from 'sweetalert2';
import {getEndpoint} from '../../helpers/endpoint';

export const uploadPicture = (file, onSuccess, type) => {
  const formData = new FormData();
  formData.append('file', file);
  return (_dispatch, getState) => {
    fetch(getEndpoint('uploadPicture', type), {
      method: 'POST',
      headers: {Authorization: getState().authentication.token},
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong with: "${data.error}"<br/>`,
          });
        } else {
          onSuccess(data.url);
        }
      })
      .catch(error => {
        swal({
          title: `Oops...`,
          type: 'error',
          html: `Something went wrong with: "${error}"<br/>`,
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/pages/Jerseys/uploadPicture.js